module.exports = "/assets/3e2aaf20efb33b091aec6fabd759860f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SJ.png
// module id = 2944
// module chunks = 0